import { Outlet } from "react-router-dom";
import { SessionProvider } from "./context/SessionContext";
import { RealtimeProvider } from "./context/RealtimeContext";
import { EntitlementsProvider } from "./context/EntitlementsContext";

const Providers = () => {
  return (
    <SessionProvider>
      <EntitlementsProvider>
        <RealtimeProvider>
          <Outlet />
        </RealtimeProvider>
      </EntitlementsProvider>
    </SessionProvider>
  );
};

export default Providers;
